module.exports = __webpack_public_path__ + "img/amazon_fresh.ba32aaf7.png";